module.exports = __webpack_public_path__ + "static/media/whatsapp.b7d5c8b0.png";